export default __webpack_public_path__ + "media/images/favicon/favicon-76x76-d0ce504a82de11f87429de2db38fc47e.png";